import axios, { AxiosResponse } from 'axios';
import { IFaqApiResponse, IFaqReqData } from '../types/api/faqApi';


const API_URL = process.env.REACT_APP_API_URL;

const customHeaders = {
    'Content-Type': 'application/json'
};
// ?page=${data.page}&limit=${data.limit}
// Sign in function with typed parameters and response
export const getFaqDataService = async (data: IFaqReqData): Promise<AxiosResponse<IFaqApiResponse>> => {
    try {
        const response = await axios.get(`${API_URL}faqs`, { headers: customHeaders });
        return response;
    } catch (error: any) {
        console.error('Error fetching auth:', error);
        // You can toast an error message if needed
        // toast.error(error?.response?.data?.msg);
        throw error;
    }
};

